import styles from './EvoachLinkify.module.css';

export const linkifyOptions = {
  format: (value: string, type: any) => {
    if (type === 'url') {
      const regex = /\[([^\]]+)\]$/;

      const match1 = value.match(regex);

      if (match1 && match1[match1.length - 1] !== null) {
        return match1[match1.length - 1];
      }
    }
    return value;
  },
  formatHref: function (href: string) {
    const regex: RegExp = /\[([^\]]+)\]$/;

    const match1: RegExpMatchArray | null = href.match(regex);
    const matchedSubstring: string | undefined = match1?.[1];

    if (matchedSubstring) {
      return href.replace(`[${matchedSubstring}]`, '');
    }
    return href;
  },
  target: 'blank_',
  className: styles['evoach-link'],
};
